
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import { Timeline, TimelineItem, DatePicker } from 'element-ui';
import { CountUp } from 'countup.js';
import Moment from 'moment';
import { IORGSTATE } from '@/store/state.d';
import api from '@/api/org';
import BS from '@/views/Home/mixins/bsMixin';
import { IPAGE } from '@/types/base.d';

@Component({
  components: {
    Timeline,
    TimelineItem,
    DatePicker,
  },
})
export default class ConsumeCard extends Mixins(BS) {
  @State org!: IORGSTATE;

  @State(state => state.org.moduleUpdate.consume) curStatus!: boolean;

  @Mutation('org/SET_ORG_CONSUME_SHOW') setConsumeShow!: Function;

  @Mutation('org/SET_ORG_CONSUME_STATUS') setConsumeStatus!: Function;

  private countUp?: CountUp;

  private loading: boolean = true;

  private page: IPAGE = {
    pageNo: 1,
    pageSize: 10,
  };

  public $refs!: {
    count: HTMLElement,
    list: HTMLElement,
  };

  private total: number = 0;

  private date: any = Date.now();

  private tList: Array<any> = [];

  mounted() {
    this.countUp = new CountUp(this.$refs.count, 0, {
      prefix: '￥',
      decimal: '.',
      decimalPlaces: 2,
    });
    this.initBS(this.$refs.list, { scrollbar: { fade: true } });
    this.getData(true);
  }

  /**
   * @author terry
   * @description 修改日期触发事件
   * @param { string } v 当前选中日期的时间戳
   */
  handleChangeDate(v: string) {
    this.getData();
  }

  /**
   * 获取数据
   * @param { boolean } handle 是否进行数组操作
   */
  getData(handle?: boolean) {
    this.loading = true;
    let date = '';
    if (this.date) date = Moment(this.date).format('YYYY-MM-DD');
    else date = Moment().format('YYYY-MM-DD');
    api.getOrgConsume(this.page, this.$route.params.pid || '', date).then((res: any) => {
      if (!handle) this.tList = res.page.content;
      else this.tList.push(...res.page.content);
      this.total = res.page.totalElements;
      this.loading = false;
      (this.countUp as CountUp).update(res.dayCost);
      this.setConsumeStatus(false);
    });
  }

  // 获取更多数据
  handleFetchMore() {
    this.getData(true);
  }

  /**
   * @author terry
   * @description 处理显示隐藏
   * @param { string } v 是否显示 true 显示  false 隐藏
   */
  handleToggle(v: boolean) {
    this.setConsumeShow(v);
  }

  @Watch('curStatus', { immediate: false, deep: true })
  handleStatusChange(v: boolean) {
    if (v) this.getData();
  }
}
